<template>
  <div class="form-item">
    <input
      :class="!isValid && 'error'"
      type="text"
      :name="field"
      :id="field"
      :maxlength="maxLenght"
      :placeholder="placeholder"
      :aria-label="placeholder"
      :value="fieldValue"
      @change="handleInput($event)"
    />
    <label :for="field"> {{ labelText }} </label>
    <p v-show="!isValid" class="rgErrorMessage">{{ errorText }}</p>
  </div>
</template>
<script>
export default {
  name: "Input",
  props: {
    field: { type: String },
    labelText: { type: String },
    placeholder: { type: String },
    maxLenght: { type: [Number, String], default: 80 },
    curValue: { type: String },
    isValid: { type: Boolean, default: true },
    errorText: { type: String },
  },
  computed: {
    fieldValue: {
      get() {
        return this.curValue;
      },
      set(val) {
        this.$emit("update:curValue", val);
      },
    },
  },
  methods: {
    handleInput(e) {
      this.fieldValue = e.target.value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Input.scss";
</style>
